import '../sigma/main'
import '../sigma/webgl'

/**
  Component enables WebGL renderer, setting it as default renderer if WebGL is supported by browser.
**/
function SigmaEnableWebGL() { return null }

export default SigmaEnableWebGL
